import classNames from 'classnames';
import React, { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';

import './ToggleItem.scss';

type Props = {
    className?: string;
    // @default false;
    asHeader?: boolean;
    // @default false;
    withSubLabel?: boolean;
    heightOverride?: number;
};

const ToggleItemSkeleton: React.FC<Props> = ({ className, heightOverride, asHeader = false, withSubLabel = false }) => {
    const height = useMemo(() => {
        if (heightOverride) return heightOverride;
        return withSubLabel ? 82 : 73;
    }, [heightOverride, withSubLabel]);
    return (
        <section
            className={classNames(
                'notifications-settings__toggle-item',
                'notifications-settings__toggle-item-skeleton',
                className,
                {
                    'notifications-settings__toggle-item--as-header': asHeader,
                },
            )}
        >
            <div style={{ flex: '1 1 auto' }}>
                <Skeleton height={height} width="100%" />
            </div>
        </section>
    );
};

export default ToggleItemSkeleton;
